export default class ScrollToAnchor {

  constructor(el) {
    this.btn = $(el);
    this.doBindings();
  }

  doBindings() {
    this.btn.on('click', this.onClickHandler.bind(this));
  }

  onClickHandler(e) {
    e.preventDefault();
    const btn = $(e.target);
    const id = btn.attr('href');
    let scrollTop = 0;
    if(id !== '#top') {
      scrollTop = $(id).offset().top;
    }

    $('html, body').animate({
      scrollTop: scrollTop - ( $('.mainheader').innerHeight() + 100),
    }, 400);
  }
}


// WEBPACK FOOTER //
// ./scripts/components/scroll-to-anchor.js